import Service from "./Service";

export default class ServiceReport extends Service {
	public fetchPort(id: number, idProducer: string) {
		return this.wrapper.get(`report/port/${id}/${idProducer}/99`);
	}

	public fetchPortTotal(id: number) {
		return this.wrapper.get(`report/total-port/${id}`);
	}

	public fetchAnnounced(id: number, idProducer: string) {
		return this.wrapper.get(`report/transit-branch/${id}/${idProducer}/99`);
	}

	public fetchBath(id: number, idProducer: string) {
		return this.wrapper.get(`report/batch-producer/${id}/${idProducer}/99`);
	}

	public fetchYard(id: number, idProducer: string) {
		return this.wrapper.get(`report/yard-producer/${id}/${idProducer}/99`);
	}

	public fetchBreakBulk(id: number, idProducer: string) {
		return this.wrapper.get(`report/board-free/${id}/${idProducer}/99`);
	}

	public fetchConsolidate(id: number, idProducer: string) {
		return this.wrapper.get(`report/consolidate-producer/${id}/${idProducer}/99`);
	}

	public fetchStacking(id: number, idProducer: string) {
		return this.wrapper.get(`report/stacking-producer/${id}/${idProducer}/99`);
	}

	public fetchSummary(id: number, idProducer: string, idBranch: number) {
		return this.wrapper.get(`report/summary/${id}/${idProducer}/${idBranch}`);
	}

	public async downloadExcel(idUser: number, idProducer: string) {
		const resp = await this.wrapper.get(`report/state-board/${idUser}/${idProducer}/99`);
		if (!resp.ok) {
			return null;
		}
		return await resp.blob()
	}
}
